enum SurveyStates {
    Open = 'open',
    Conducting = 'conducting',
    Completed = 'completed',
    Disabled = 'disabled',
    Deleted = 'deleted',
    Delivery = 'delivery',
    Preparation = 'preparation',
    Reporting = 'reporting',
}

export const surveyStatesArray = Object.values(SurveyStates);

export { SurveyStates };
